// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EntrypointComponent } from './entrypoint/entrypoint.component';

const routes: Routes = [
    {
        path: 'entrypoint',
        component: EntrypointComponent,
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SelfEnrollmentRoutingModule {}
